import React from "react";
import { createPortal } from "react-dom";
import env from "../env.json";

export type Urls = Array<string | { src: string, type: number, }>;

export interface LightBoxRef {
    show: (urls: Urls, index: number) => void;
    hide: () => void;
}

export default React.forwardRef<LightBoxRef, {}>(function LightBox(_, ref) {
    const {0: urls, 1: setUrls} = React.useState<Urls>([]);
    const {0: index, 1: setIndex} = React.useState(0);
    let url = React.useMemo(() => {
        if (!urls[index]) {
            return '';
        }
        let result = typeof urls[index] === 'string' ? urls[index] : urls[index].src;
        if (result[0] === '/') {
            result = env.RES_URL + result.substring(1);
        }
        return result;
    }, [urls, index]);
    const {0: status, 1: setStatus} = React.useState(false);
    let handler = React.useMemo<LightBoxRef>(() => ({
        show: (urls, index = 0) => {
            setUrls(urls);
            setIndex(index);
            setStatus(true);
        },
        hide: () => setStatus(false)
    }), [status]);
    React.useImperativeHandle(ref, () => handler, [handler]);
    return status ? createPortal((
        <div className="lightbox">
            <div className="mask" onClick={handler.hide}></div>
            {urls.length > 1 ? (
                <ul className="list">
                    {urls.map((url, i) => {
                        url = typeof url === 'string' ? url : url.src;
                        if (url[0] === '/') {
                            url = env.RES_URL + url.substring(1);
                        }
                        return (
                            <li key={'l-' + i} className={i === index ? 'active' : ''} onClick={setIndex.bind(null, i)}>
                                <img src={url} alt="" width="50" height="50" />
                            </li>
                        );
                    })}
                </ul>
            ) : null}
            {typeof urls[index] === 'string' || urls[index].type === 0 ? (
                <img src={url} alt="" className="current" />
            ) : (
                <video src={url} controls={true} autoPlay={true} className="current" />
            )}
        </div>
    ), document.body) : null;
});
